import React, { useEffect } from "react";
import { Banner, BannerCTAs } from "../Banner/Banner";
import { IconPeopleThree } from "src/components/ui-components/Icons/IconPeopleThree";
import { useAnalytics } from "src/components/analytics/analytics";
import { AnchorButton } from "src/components/ui-components/Button/AnchorButton";
import AmplitudeService from "src/services/amplitude";

export interface CreateTeamPromptBannerProps {
  userId: number;
  onDismiss: () => void;
}

export const CreateTeamPromptBanner = ({
  userId,
  onDismiss,
}: CreateTeamPromptBannerProps) => {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.captureEvent("create_team_prompt_banner_shown", {
      userId,
    });
    AmplitudeService.trackEvent("Create Team Prompt Banner Viewed");
  }, []);

  return (
    <Banner
      dismissable
      onDismiss={() => {
        analytics.captureEvent("create_team_prompt_banner_dismissed", {
          userId,
        });
        AmplitudeService.trackEvent("Create Team Prompt Banner Dismissed");
        onDismiss();
      }}
    >
      <IconPeopleThree />
      Using Dune for work? Protect private content and invite collaborators when
      you create a team account.
      <BannerCTAs>
        <AnchorButton
          size="S"
          theme="primary"
          href="/teams/new"
          onClick={() => {
            analytics.captureEvent("create_team_prompt_banner_clicked", {
              userId,
            });
            AmplitudeService.trackEvent(
              "Create Team Prompt Banner - Create Team Clicked"
            );
          }}
        >
          Create team
        </AnchorButton>
      </BannerCTAs>
    </Banner>
  );
};
